module.exports = __webpack_public_path__ + "img/sports_thumbnail-400x300.78d1ad73.jpg";